<template>
  <div class="notification-main-container">
    <h1>{{ this.displayNotificationHeader }} <span v-if="this.unreadCount > 0">({{ this.unreadCount }} new)
    </span>
      <span @click.prevent="showHelpBubble" id="notification-help-popup" class="acclaro-icon ai-info clickable"></span>
    </h1>
    <div class="user-notification-filter-panel">
      <notification-filters-top  />
    </div>
    <div v-if="this.error">
      <div class="no-notifications-container">
        <h2>Oops, something's not right...</h2>
      </div>
    </div>
    <div v-else-if="this.loading" class="user-notification-container ">
    </div>
    <div v-else class="user-notification-container">
      <div class="notification-admin-filters-container-outer">
        <notification-filters-left-panel />
      </div>
      <div style="width: 100%">
        <div id="notifications-log-table" v-if="this.notifications.length">
          <div id="app" v-cloak>
            <table class="tableup admin-account-contact-table">
              <tbody class="notification-table">
              <tr :key="notification.id" v-for="notification in this.notifications">
                <notification :notification="notification"></notification>
              </tr>
              </tbody>
            </table>
            <notification-pagination />
          </div>
        </div>
        <div v-else>
          <no-notifications-panel/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoNotificationsPanel from "./no-notifications-panel.vue";
import NotificationFiltersTop from "./notification-filters-top.vue";
import NotificationFiltersLeftPanel from "./notification-filters-left-panel.vue";
import NotificationPagination from "./notification-pagination.vue";
import Notification from './notification'
import {mapMutations, mapState, mapActions, mapGetters} from 'vuex';
import './user-notifications.scss';

export default {
  components: {
    NoNotificationsPanel,
    NotificationFiltersTop,
    NotificationFiltersLeftPanel,
    NotificationPagination,
    Notification,
  },
  mounted () {
    this.fetchNotifications(this.requestUrl);
  },
  computed: {
    ...mapState('PortalNotificationStore', [
      'unreadCount',
      'notifications',
      'user',
      'account',
      'notificationType',
      'loading',
      'error',
      'showNotificationsFor',
      "paginationDetails",
      "assignedOnly"
    ]),
    ...mapGetters('PortalNotificationStore', [
      'requestUrl',
      'showingNotificationsForName'
    ]),
    displayNotificationHeader(){
      if(this.assignedOnly){
        return `My Assigned Order Notifications`
      } else {
        return `${this.showingNotificationsForName}'s Notifications`;
      }
    }
  },
  methods: {
    ...mapActions('PortalNotificationStore', [
      'fetchNotifications'
    ]),
    ...mapMutations('PortalNotificationStore', [
      'setNotificationType',
      'toggleFlaggedOnly',
    ]),
    showHelpBubble () {
      $('#notification-help-popup').click(function () {
        showPopupPage('notifications-help', 'Notification Help');
      });
    },
  },
};

</script>
